import { createSlice } from '@reduxjs/toolkit';

/* ----------------------------------------------------------------
      SLICE (ACTIONS/REDUCERS)
---------------------------------------------------------------- */

const initialState = {
  state: null,
  options: {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center',
    },
    autoHideDuration: 6000,
    message: 'Hi',
    variant: null,
  },
};

const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    hideMessage(state) {
      state.state = null;
    },
    showMessage(state, action) {
      state.state = true;
      state.options = {
        ...initialState.options,
        ...action.payload,
      };
    },
  },
});

export const { hideMessage, showMessage } = messageSlice.actions;
export default messageSlice.reducer;
